import React, { useMemo } from 'react'
import {
    Button,
    IconLib,
    Menu,
    MenuItemOption,
    MenuOptionGroup,
    Popover,
    Portal,
    View,
    stopEvent,
    useVisibility,
} from '@fold-dev/core'
import { ActionButton, ToolbarButton } from './'

export type Priority = '' | 'low' | 'medium' | 'high'

export type PriorityButtonProps = {
    priority: Priority
    title?: string
    onChange: (val) => void
    portal?: any
    disabled?: boolean
}

export const PriorityButton = (props: PriorityButtonProps) => {
    const { title = 'Priority', onChange, portal, disabled } = props
    const priority = props.priority ? props.priority : ''
    const { visible, show, hide } = useVisibility(false)
    const { color, label } = useMemo(() => {
        let color, label

        switch (priority) {
            case 'low':
                color = 'var(--f-color-caution)'
                label = 'Low Priority'
                break
            case 'medium':
                color = 'var(--f-color-warning)'
                label = 'Medium Priority'
                break
            case 'high':
                color = 'var(--f-color-danger)'
                label = 'High Priority'
                break
        }

        return { color, label }
    }, [priority])

    return (
        <Popover
            portal={portal}
            focusTrap
            width={150}
            content={
                <Menu
                    width="100%"
                    border="none">
                    <MenuOptionGroup
                        title={title}
                        defaultValue={priority}
                        type="radio"
                        onChange={(priority: any) => {
                            onChange(priority == '' ? null : priority)
                            hide()
                        }}>
                        <MenuItemOption
                            icon="flag"
                            value="">
                            None
                        </MenuItemOption>
                        <MenuItemOption
                            icon="flag"
                            value="low"
                            style={{
                                '--f-menu-item-color-active': 'var(--f-color-caution)',
                                '--f-menu-item-background-color-active': 'var(--f-color-caution-weak)',
                            }}>
                            Low
                        </MenuItemOption>
                        <MenuItemOption
                            icon="flag"
                            value="medium"
                            style={{
                                '--f-menu-item-color-active': 'var(--f-color-warning)',
                                '--f-menu-item-background-color-active': 'var(--f-color-warning-weak)',
                            }}>
                            Medium
                        </MenuItemOption>
                        <MenuItemOption
                            icon="flag"
                            value="high"
                            style={{
                                '--f-menu-item-color-active': 'var(--f-color-danger)',
                                '--f-menu-item-background-color-active': 'var(--f-color-danger-weak)',
                            }}>
                            High
                        </MenuItemOption>
                    </MenuOptionGroup>
                </Menu>
            }
            isVisible={visible}
            onDismiss={hide}>
            <div
                className="f-row action-button-parent"
                style={{
                    color,
                    gap: 5,
                }}>
                <ActionButton
                    border
                    style={{
                        color,
                        borderWidth: 1,
                        borderColor: color ? color : undefined,
                        borderStyle: label ? 'solid' : 'dashed',
                    }}
                    onClick={show}>
                    <IconLib
                        icon="flag"
                        size="sm"
                    />
                </ActionButton>

                {label && (
                    <div
                        onClick={(e) => {
                            stopEvent(e)
                            show()
                        }}
                        className="f-text sm"
                        style={{ color }}>
                        {label}
                    </div>
                )}
            </div>
        </Popover>
    )
}
